(function () {
    'use strict';

    angular.module("imApp").factory("listsService", ['$ihttp', function ($ihttp) {
        let service = {
            lists: function (parms) {
                return $ihttp.post({
                    method: 2715,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
